module.exports = __webpack_public_path__ + "img/upgrade.01d509e0.png";